"use client";

import React, { useEffect, useState } from "react";
import { Calendar, User, Clock, ArrowRight, Share2, Tag, ChevronRight, MessageCircle, Facebook, Linkedin, Link2, Check, Mail, Twitter, Bookmark, MessageSquare, ChartBar as BarChart3, Star } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import Engagementstatsdisplay from './Engagementstatsdisplay';
import ArticleMetaInfo from './Articlemetainfo';

declare const wvcClient: any;

function SidebarConsumer({ title }: { title: string }) {
  const { posts, loading } = usePosts();
  if (loading) return <div className="animate-pulse h-64 bg-muted/20 rounded-lg" />;
  return (
    <div className="space-y-6">
      <h3 className="font-serif font-bold text-lg border-b border-border pb-2">{title}</h3>
      {posts.map((post, i) => (
        <div key={post.id} data-index={i} className="group flex gap-4">
          {post.featuredImage && (
            <img src={post.featuredImage} alt={post.title} className="w-20 h-16 object-cover rounded-md" />
          )}
          <div className="flex-1">
            <Link to={post.link || "#"} className="text-sm font-bold leading-tight group-hover:text-primary line-clamp-2">
              {post.title}
            </Link>
            <p className="text-[10px] text-muted-foreground mt-1">
              {post.date && new Date(post.date).toLocaleDateString('id-ID')}
            </p>
          </div>
        </div>
      ))}
      <Link to="/NewsPage" className="block text-xs font-bold uppercase text-primary hover:underline">Lihat Semua</Link>
    </div>
  );
}

function SinglePostConsumer() {
  const { posts, loading, error } = usePosts();
  const post = posts[0];
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

  if (loading) return <div className="container mx-auto py-24 text-center">Memuat...</div>;
  if (error || !post) return <div className="container mx-auto py-24 text-center">Konten tidak tersedia.</div>;

  return (
    <article className="bg-background pb-24 relative z-0">
      <header className="pt-8 pb-4">
        <div className="container mx-auto max-w-[1280px] px-4">
        </div>
      </header>

      <div className="container mx-auto max-w-[1280px] px-4">
        <div className="grid grid-cols-1 lg:grid-cols-[240px_1fr_280px] gap-6">
          <aside className="hidden lg:block space-y-8">
            <PostsProvider wp_query={new WP_Query({ post_type: "post", posts_per_page: 5 })}>
              <SidebarConsumer title={`TERBARU DI ${post.categories?.[0]?.name || "BERITA"}`} />
            </PostsProvider>
          </aside>

          <main className="px-4 md:px-6 lg:px-0">
            <div className="flex items-center gap-2 text-xs text-muted-foreground mb-4">
              <Link to="/">Beranda</Link> <span>›</span>
              <Link to={post.categories?.[0]?.link || "#"}>{post.categories?.[0]?.name || "Berita"}</Link>
            </div>
            <h1 className="text-4xl md:text-5xl font-serif font-bold leading-[1.2] mb-4">{post.title}</h1>
            <div className="mb-0">
              <ArticleMetaInfo post={post} />
            </div>
            <div className="mb-2">
              <Button variant="ghost" size="sm" onClick={() => {}}><Share2 className="size-4" /> Bagikan</Button>
            </div>

            {post.featuredImage && (
              <figure className="mb-0">
                <img src={post.featuredImage} alt={post.title} className="w-full rounded-lg shadow-sm" />
                {post.excerpt && <figcaption className="mt-2 mb-6 text-sm italic text-muted-foreground text-center">Foto: Dokumentasi ABADI.NEWS</figcaption>}
              </figure>
            )}

            <div className="prose prose-stone max-w-none" dangerouslySetInnerHTML={{ __html: post.content || "" }} />

            <div className="mt-6 p-4 border border-border rounded-lg bg-muted/10">
              <h3 className="font-bold text-lg mb-4">INFORMASI PUBLIKASI</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                <div><p className="text-muted-foreground text-xs">Reporter</p><p className="font-bold">{post.author?.name}</p></div>
                <div><p className="text-muted-foreground text-xs">Diterbitkan</p><p className="font-bold">{new Date(post.date || "").toLocaleDateString()}</p></div>
                <div><p className="text-muted-foreground text-xs">Durasi Baca</p><p className="font-bold">{Math.ceil((post.content?.length || 0) / 1000)} menit</p></div>
                <div><p className="text-muted-foreground text-xs">Dibaca</p><p className="font-bold">125 Pembaca</p></div>
              </div>
            </div>

            <div className="flex gap-4 mt-3">
              <Button variant="outline" asChild><Link to="#">AJUKAN KLARIFIKASI</Link></Button>
              <Button variant="outline" asChild><Link to="#">KIRIM HAK JAWAB</Link></Button>
            </div>

            <div className="mt-6 border-y py-8">
              <Engagementstatsdisplay postId={post.id} />
            </div>
          </main>

          <aside className="hidden lg:block space-y-8">
            <PostsProvider wp_query={new WP_Query({ post_type: "post", posts_per_page: 5 })}>
              <SidebarConsumer title="PEMBARUAN TERBARU" />
            </PostsProvider>
          </aside>
        </div>
        
        <div className='lg:hidden mt-12 space-y-8 grid grid-cols-1 md:grid-cols-2 gap-8'>
            <PostsProvider wp_query={new WP_Query({ post_type: "post", posts_per_page: 5 })}>
              <SidebarConsumer title={`TERBARU DI ${post.categories?.[0]?.name || "BERITA"}`} />
            </PostsProvider>
            <PostsProvider wp_query={new WP_Query({ post_type: "post", posts_per_page: 5 })}>
              <SidebarConsumer title="PEMBARUAN TERBARU" />
            </PostsProvider>
        </div>
      </div>
    </article>
  );
}

export default function SinglePostTemplateSection() {
  const currentWPQueryParams = wvcClient.getCurrentWPQueryParams();
  const wp_query = new WP_Query(currentWPQueryParams);

  return (
    <section id="single-post-template-section" className="bg-background text-foreground">
      <PostsProvider wp_query={wp_query}>
        <SinglePostConsumer />
      </PostsProvider>
    </section>
  );
}